import { render, staticRenderFns } from "./OrderSummaryAssetComponent.vue?vue&type=template&id=582793c8&"
import script from "./OrderSummaryAssetComponent.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryAssetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports